import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Subject, throttleTime } from 'rxjs';
import { SizeElements } from 'src/app/core/_models/base.model';

@Component({
  selector: 'forrest-btn',
  templateUrl: './btn.component.html',
  styleUrls: ['./btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BtnComponent {
  @Input() title?: string;
  @Input() color?: string;
  @Input() disabled: boolean = false;
  @Input() btnFullWidth: boolean = true;
  @Input() icon: string | null = null;
  @Input() size: SizeElements = 'xl';
  @Output() eventClick = new EventEmitter<boolean>();

  private clickSubject = new Subject<void>();

  constructor(private cdr: ChangeDetectorRef) {
    this.clickSubject.pipe(throttleTime(500)).subscribe(() => {
      this.eventClick.emit(true);
      this.cdr.markForCheck();
    });
  }

  handleClick() {
    if (!this.disabled) {
      this.clickSubject.next();
    }
  }
}
